module.exports = __webpack_public_path__ + "img/CITROEN.1c85cea.jpg";